define(function() {
    'use strict';
    return {
        'mapboxgl.version': '0.50.0',
        'sdk.version': '4.40.10',
        'analytics.header.name': 'TomTom-User-Agent',
        'analytics.header.sdkName': 'MapsWebSDK',

        // copyrights
        'endpoints.copyrightsWorld': 'api.tomtom.com/map/1/copyrights.{contentType}',
        'endpoints.copyrightsBounds': 'api.tomtom.com/map/1/copyrights/{minLon}/{minLat}/{maxLon}/{maxLat}.{contentType}',
        'endpoints.caption': 'api.tomtom.com/map/1/copyrights/caption.{contentType}',

        // search
        'endpoints.geocode': 'api.tomtom.com/search/2/geocode/{query}.{contentType}',
        'endpoints.structuredGeocode': 'api.tomtom.com/search/2/structuredGeocode.{contentType}',
        'endpoints.search': 'api.tomtom.com/search/2/{type}/{query}.{contentType}',
        'endpoints.batchSearch': 'api.tomtom.com/search/2/batch.{contentType}',
        'endpoints.batchSyncSearch': 'api.tomtom.com/search/2/batch/sync.{contentType}',
        'endpoints.batchSearchQuery': '/{type}/{query}.{contentType}',
        'endpoints.adp': 'api.tomtom.com/search/2/additionalData.{contentType}',
        'endpoints.reverseGeocode': 'api.tomtom.com/search/2/{type}/{position}.{contentType}',

        // traffic
        'endpoints.trafficIncidents': 'api.tomtom.com/traffic/services/4/incidentDetails/{style}/{minLat},{minLon},{maxLat},{maxLon}/{zoom}/{trafficModelID}/{contentType}',
        'endpoints.trafficViewport': 'api.tomtom.com/traffic/services/4/incidentViewport/0,0,.1,.1/0/0,0,.1,.1/0/false/{contentType}',
        'endpoints.flowSegmentData': 'api.tomtom.com/traffic/services/4/flowSegmentData/{style}/{zoom}/{contentType}',
        'endpoints.incidentRegions': 'api.tomtom.com/traffic/services/4/incidentRegions/{contentType}',

        // layers
        'endpoints.trafficLayer': '{s}.api.tomtom.com/traffic/map/4/tile/incidents/{style}/{z}/{x}/{y}.png',
        'endpoints.trafficFlowLayer': '{s}.api.tomtom.com/traffic/map/4/tile/flow/{style}/{z}/{x}/{y}.png',
        'endpoints.tileLayer': '{s}.api.tomtom.com/map/1/tile/{layer}/{style}/{z}/{x}/{y}.png',

        // routing
        'endpoints.routing': 'api.tomtom.com/routing/1/calculateRoute/{locations}/{contentType}',
        'endpoints.reachableRange': 'api.tomtom.com/routing/1/calculateReachableRange/{origin}/{contentType}',
        'endpoints.batchRouting': 'api.tomtom.com/routing/1/batch/{contentType}',
        'endpoints.batchSyncRouting': 'api.tomtom.com/routing/1/batch/sync/{contentType}',
        'endpoints.batchRoutingQuery': '/calculateRoute/{locations}/{contentType}',
        'endpoints.batchReachableRangeQuery': '/calculateReachableRange/{origin}/{contentType}',
        'endpoints.matrixRouting': 'api.tomtom.com/routing/1/matrix/{contentType}',
        'endpoints.matrixSyncRouting': 'api.tomtom.com/routing/1/matrix/sync/{contentType}',

        //static map image
        'endpoints.staticMapImage': 'https://api.tomtom.com/map/1/staticimage',

        'vector.glyphs': 'https://api.tomtom.com/maps-sdk-js/4.40.10/glyphs/{fontstack}/{range}.pbf',
        'vector.sprites': 'https://api.tomtom.com/maps-sdk-js/4.40.10/sprites/sprite'
    };
});




// WEBPACK FOOTER //
// /home/ubuntu/jenkins/workspace/rp_start_release_npm/jssdk/build/mainConfig.js